// Las políticas se recorren como una sola página: el contenido se cambia en sitio y
// la URL sustituye a la anterior, así volver atrás lleva al menú y no a la política previa.
(() => {
  const index = document.querySelector('.av-policy-index');
  if (!index) return;
  const container = () => document.querySelector('.shopify-policy__container');
  let busy = false;
  function mark(pathname) {
    index.querySelectorAll('a[href]').forEach(link => {
      if (new URL(link.href, location.href).pathname === pathname) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  index.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.href === location.href || !container() || busy) return;
    event.preventDefault();
    busy = true;
    try {
      const response = await fetch(destination.href);
      if (!response.ok) throw new Error('La política no respondió.');
      const document_ = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = document_.querySelector('.shopify-policy__container');
      if (!incoming) throw new Error('La política llegó vacía.');
      incoming.classList.add('av-appear');
      container().replaceWith(incoming);
      document.title = document_.title;
      history.replaceState({}, '', destination.href);
      mark(destination.pathname);
      scrollTo(0, 0);
    } catch (_) {
      location.assign(destination.href);
    } finally {
      busy = false;
    }
  });
})();
